import { ANIMATION } from '@/constants/animation';
import type { valueof } from './valueof';

export enum ScreenSize {
  TINY,
  X_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
  X_LARGE
}

export type AnimationType = valueof<typeof ANIMATION>;
